/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import React from 'react';
import {Text,
View,
StyleSheet,
Pressable} from 'react-native';
import {Badge, Icon, Button} from 'react-native-elements';
import { useNavigation } from '@react-navigation/native';

const CatalogUpdate = (props) => {
const navigation = useNavigation();
return (
<>
{props.viewed? (
<Pressable
style={({ pressed }) => [
    { opacity: pressed ? 0.5 : 1.0 }
  ]}
onPress={() => {
    console.log(`Update Pressed ${props.id}`)
try {
    navigation.navigate('CatalogUpdate', {update: props.id}); //CatalogUpdates
}
catch (e) {
        console.error(`Error opening catalog update: ${e}`);

}

}}>
<View style={styles.updateContainer}>
<Text style={styles.updateCatalogRead}>{props.catalog}</Text>
<Text style={styles.updateDateRead}>{props.date}</Text>
<Text style={styles.updateTitleRead}>{props.title}</Text>
<Text style={styles.updateDescriptionRead} numberOfLines={1} ellipsizeMode={"tail"}>{props.description}</Text>
{props.favorite? (
<Icon containerStyle={{position:'absolute', top: 8, right: 8}}
name='star'
type='MaterialCommunityIcons'
color='red'
/>
) : (
<Icon containerStyle={{position:'absolute', top: 8, right: 8}}
name='check'
type='MaterialCommunityIcons'
color='lightgray'
/>
)}
</View>
</Pressable>
): (
<Pressable
style={({ pressed }) => [
    { opacity: pressed ? 0.5 : 1.0 }
  ]}
onPress={() => {
navigation.navigate('Catalog Updates', {update: props.id})}}>
<View style={styles.updateContainerUnread}>
<Text style={styles.updateCatalogUnread}>{props.catalog}</Text>
<Text style={styles.updateDateUnread}>{props.date}</Text>
<Text style={styles.updateTitleUnread}>{props.title}</Text>
<Text style={styles.updateDescriptionUnread} numberOfLines={1}>{props.description}</Text>
<Badge value="New" containerStyle={{ position: 'absolute', top: 8, right: 8 }} status="error" />
</View>
</Pressable>
)}
</>
)
}

const styles = StyleSheet.create({
updateCatalogRead: {
fontSize: 20,
},
updateDateRead: {
fontSize: 12
},
updateTitleRead: {
fontSize: 16
},
updateDescriptionRead: {
},
updateCatalogUnread: {
fontWeight: "bold",
fontSize: 20,
},
updateDateUnread: {
fontWeight: "bold",
fontSize: 12
},
updateTitleUnread: {
fontWeight: "bold",
fontSize: 16
},
updateContainer: {
marginTop: 16,
borderBottomColor: '#cccccc',
borderBottomWidth: 1,
backgroundColor: '#FFFFFF',
borderRadius: 8,
paddingTop: 10,
paddingLeft: 20,
paddingRight: 20,
paddingBottom: 10,
},
updateContainerUnread: {
marginTop: 16,
borderBottomColor: '#cccccc',
borderBottomWidth: 1,
borderRadius: 8,
paddingTop: 10,
paddingLeft: 20,
paddingRight: 20,
paddingBottom: 10,
backgroundColor: "#e3edff",
},
});

export default CatalogUpdate;